<template>
  <ModalLayout icon="approve-in-circle" :title="`Approve ${meta?.flight ? 'flight' : 'campaign'}?`" @close="close">
    <p>
      You are about to approve '<strong>{{ name }}</strong
      >'. Once approved, no further changes can be made. Are you sure you want to proceed?
    </p>

    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" icon="el-icon-check" type="primary" :loading="loading" @click="approve">Approve</el-button>
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from './ModalLayout.vue'
export default {
  name: 'Approve',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    name() {
      return this.meta?.flight ? `${this.meta?.flight.name}` : this.meta?.campaign?.name
    },
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async approve() {
      this.loading = true
      try {
        await this.$store.dispatch('socialBoostCampaign/approve', {
          campaign_id: this.meta?.id || this.$route.params.id,
          flight_id: this.meta?.flight_id || this.$route.params.flight_id,
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
        this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.meta?.id || this.$route.params.id })
        this.close()
      }
    },
  },
}
</script>
